import React from 'react';
import { X, Check } from 'lucide-react';
import { HOW_STEPS, COMPARE } from '../mock';

const WhyHow = () => (
  <>
    <section className="section" id="how" style={{ background: 'var(--pink)' }} data-testid="how-section">
      <div className="container">
        <div className="section-title">
          <div className="eyebrow">Simple process</div>
          <h2>From “maybe” to “let’s talk.”</h2>
          <p>A simple matchmaking journey without the dating-app fatigue.</p>
        </div>
        <div className="process">
          {HOW_STEPS.map((s) => (
            <div className="step-card" key={s.num}>
              <div className="num">{String(s.num).padStart(2, '0')}</div>
              <div className="step-body">
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="section" id="why" data-testid="why-section">
      <div className="container">
        <div className="section-title">
          <div className="eyebrow">Why Krysha</div>
          <h2>Dating should feel personal again.</h2>
          <p>No left. No right. No pressure. Here is how Krysha compares to the endless swipe.</p>
        </div>
        <div className="compare">
          <div className="comp-col apps">
            <h3>{COMPARE.apps.title}</h3>
            {COMPARE.apps.items.map((it) => (
              <div className="comp-item" key={it}><span className="ci bad"><X size={13} /></span>{it}</div>
            ))}
          </div>
          <div className="comp-col krysha">
            <h3>{COMPARE.krysha.title}</h3>
            {COMPARE.krysha.items.map((it) => (
              <div className="comp-item" key={it}><span className="ci good"><Check size={13} /></span>{it}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default WhyHow;
